/* eslint-disable no-useless-escape */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-script-url */
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Step from '@mui/material/Step'
import StepButton from '@mui/material/StepButton'
import Stepper from '@mui/material/Stepper'
import Typography from '@mui/material/Typography'
import React, { useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { UnsavedChangesModal } from '../../../common/components/UnsavedChangesModal'
import { useUnsavedChanges } from '../../../common/hooks/useUnsavedChanges'
import { useFundSeries } from './hooks/useFundSeries'
import { StrategyTab } from './components/StrategyTab'
import { PortfolioTab } from './components/PortfolioTab'
import { InfoRiesgoTab } from './components/InfoRiesgoTab'
import { ContentTab } from './components/ContentTab'
import { QuoteValueTab } from './components/QuoteValueTab'
import { PerformanceTab } from './components/PerformanceTab'

const steps = [
  'INFORMACIÓN Y RIESGO',
  'ESTRATEGIA DE INVERSIÓN',
  'RENDIMIENTO',
  'DESEMPEÑO',
  'PORTAFOLIO',
  'CONTENIDO',
]

export const ConfigFunds = () => {
  const { id: fundId } = useParams()
  useFundSeries(fundId)

  const [activeStep, setActiveStep] = React.useState(0)
  const [completed, setCompleted] = React.useState<{ [k: number]: boolean }>({})
  const [activeTabDirty, setActiveTabDirty] = useState(false)
  const activeTabSaveRef = useRef<(() => Promise<void>) | null>(null)

  const { guardNavigation, isModalOpen, handleLeave, handleCancel, handleSaveAndContinue, saving } =
    useUnsavedChanges(
      activeTabDirty,
      async () => { await activeTabSaveRef.current?.() },
      { blockRouter: true }
    )

  const totalSteps = () => steps.length
  const completedSteps = () => Object.keys(completed).length
  const isLastStep = () => activeStep === totalSteps() - 1
  const allStepsCompleted = () => completedSteps() === totalSteps()

  const switchToStep = (step: number) => {
    setActiveTabDirty(false)
    setActiveStep(step)
  }

  const handleNext = (e: any) => {
    e.preventDefault()
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1
    guardNavigation(() => switchToStep(newActiveStep))
  }

  const handleBack = (e: any) => {
    e.preventDefault()
    guardNavigation(() => switchToStep(activeStep - 1))
  }

  const handleStep = (step: number) => () => {
    guardNavigation(() => switchToStep(step))
  }

  const handleReset = () => {
    setActiveStep(0)
    setCompleted({})
  }

  const tabProps = {
    onDirtyChange: setActiveTabDirty,
    saveRef: activeTabSaveRef,
  }

  return (
    <form>
      <Box sx={{ width: '100%' }}>
        <Stepper
          nonLinear
          className='d-flex flex-grow flex-wrap gap-5 mt-5'
          activeStep={activeStep}
        >
          {steps.map((label, index) => (
            <Step key={label} completed={completed[index]}>
              <StepButton color='inherit' onClick={handleStep(index)}>
                {label}
              </StepButton>
            </Step>
          ))}
        </Stepper>
        <div>
          {allStepsCompleted() ? (
            <React.Fragment>
              <Typography sx={{ mt: 2, mb: 1 }}>
                All steps completed - you&apos;re Finalizado
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                <Box sx={{ flex: '1 1 auto' }} />
                <Button onClick={handleReset}>Restablecer</Button>
              </Box>
            </React.Fragment>
          ) : (
            <div>
              <React.Fragment>
                <div>
                  {activeStep === 0 ? (
                    <InfoRiesgoTab fundId={fundId!} {...tabProps} />
                  ) : activeStep === 1 ? (
                    <StrategyTab fundId={fundId!} {...tabProps} />
                  ) : activeStep === 2 ? (
                    <PerformanceTab fundId={fundId!} {...tabProps} />
                  ) : activeStep === 3 ? (
                    <QuoteValueTab fundId={fundId!} {...tabProps} />
                  ) : activeStep === 4 ? (
                    <PortfolioTab fundId={fundId!} {...tabProps} />
                  ) : (
                    activeStep === 5 && <ContentTab fundId={fundId!} {...tabProps} />
                  )}
                </div>
                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                  <Button
                    color='inherit'
                    disabled={activeStep === 0}
                    onClick={(e) => handleBack(e)}
                    sx={{ mr: 1 }}
                    type='submit'
                  >
                    Anterior
                  </Button>
                  <Box sx={{ flex: '1 1 auto' }} />
                  {activeStep !== 5 && (
                    <Button onClick={(e) => handleNext(e)} sx={{ mr: 1 }} type='submit'>
                      Siguiente
                    </Button>
                  )}
                </Box>
              </React.Fragment>
            </div>
          )}
        </div>
      </Box>

      {isModalOpen && (
        <UnsavedChangesModal
          onLeave={handleLeave}
          onCancel={handleCancel}
          onSave={handleSaveAndContinue}
          saving={saving}
        />
      )}
    </form>
  )
}
